module.exports = __webpack_public_path__ + "450de3015d748597ffa9d174659c5255.svg";